import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseApiService, HubspotApiService } from '../api';
import { HubspotSettingsResponseDto, HubspotWorkflowDto, LifecycleStageDto, MappingFieldsRequestParamDto } from '../../dto';
import { CrmServiceInterface } from './interface';
import { ExportTypeEnum } from '../../enums';
import { AbstractCrmService } from './abstract-crm-service';

@Injectable({
  providedIn: 'root',
})
export class HubspotService extends AbstractCrmService implements CrmServiceInterface<boolean> {
  hsCrmStatusToggledBeforeRelogin: boolean = false;

  constructor(
    readonly hubspotApiService: HubspotApiService,
    readonly baseApiService: BaseApiService,
  ) {
    super(baseApiService);
  }

  getExportType(): ExportTypeEnum {
    return ExportTypeEnum.HUBSPOT;
  }

  authenticate(code: string, hsCrmValue?: boolean): Observable<any> {
    return this.hubspotApiService.authenticate(code, hsCrmValue);
  }

  logout(): Observable<any> {
    // THIS WILL COMPLETELY LOG THE USER OUT OF HUBSPOT...
    const iframe = document.createElement('iframe');
    iframe.src = 'https://app.hubspot.com/login-api/v1/logout/all';
    iframe.style.cssText = 'position:fixed;top:0;left:0;display:none;width:100px;height:100px;z-index:0;';
    document.body.appendChild(iframe);
    return this.hubspotApiService.logout();
  }

  setSettings(payload: any): Observable<any> {
    return this.hubspotApiService.saveSettings(payload);
  }

  getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
    return this.hubspotApiService.getMappingFields(params);
  }

  loadLeadOwner(): Observable<any> {
    return this.hubspotApiService.loadLeadOwner();
  }

  loadWorkflows(showError: boolean): Observable<HubspotWorkflowDto[]> {
    return this.hubspotApiService.loadWorkflows(showError);
  }

  getLifecycleStages(): Observable<LifecycleStageDto[]> {
    return this.hubspotApiService.getLifecycleStages();
  }

  getScopes(): Observable<any> {
    return this.hubspotApiService.getScopes();
  }

  getSettings(): Observable<HubspotSettingsResponseDto> {
    return this.hubspotApiService.getSettings();
  }
}
